import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Select from 'react-select'
import styles from './selectComponent.css'
import 'react-select/dist/react-select.css';

const stylesLocal = {
  pointerEvents: 'none'
}

const style = {
  color: '#F97B7C',
  fontSize: '1.2rem'
}

class SelectComponent extends Component {
  state = {
    value :''
  }
  componentDidMount(){
    const {val} = this.props
    this.setState({
      value: val
    })
  }

  onChange(value){
    const {selectWorkTeam} = this.props
    this.setState({
      value: value
    })
    this.props.input.onChange(value)
    if(selectWorkTeam){
      console.log('!!!select')
      selectWorkTeam(value)
    }
  }

  render() {
    const {input, name, placeholder, options, val, meta: {touched, error}} = this.props
    console.log(val)
    console.log('SelectComponenttttt')
    console.log(this.props)
    return (
      <div className='select'>
        <Select
          name={name}
          onChange={this.onChange.bind(this)}
          placeholder={placeholder}
          options={options}
          value={this.state.value}
          className={styles.selectItem}
        />
        {touched && error && <span style={style}>{error}</span>}
      </div>
    )
  }
}

export default CSSModules(SelectComponent, styles)


// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/SelectComponent.js